import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const DivStyled = styled.div`
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));

    return css`
      display: flex;
      width: 100%;
      height: 100%;
      background-color: ${theme.colors.primary.blue};
      overflow-x: hidden;
      &#{&} {
        position: fixed;
        z-index: ${theme.zIndex.globalNavMain};
        top: 0;
        right: 0;
        width: ${rem(80)};
        height: ${rem(50)};
        ${mediumUp && css`
          position: relative;
          top: auto;
          right: auto;
          width: auto;
          height: auto;
        `}
      }
  `;
  }
}
`;

export const DivLogoutFramesStyled = styled.div`
  display: none;
`;

export const ButtonStyled = styled.button`
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const xlargeUp = theme.useMediaQuery(theme.breakpoints.up('xlarge'));
    let paddingTop = '0';

    if (xlargeUp) {
      paddingTop = rem(8);
    } else if (mediumUp) {
      paddingTop = rem(6);
    }

    return css`
      display: inline-block;
      width: ${mediumUp ? 'auto' : rem(80)};
      height: 100%;
      border: none;
      margin: ${mediumUp ? '0' : '0 auto'};
      background-color: ${theme.colors.primary.blue};
      border-radius: 0;
      color: ${theme.colors.neutral.white};
      cursor: pointer;
      text-transform: uppercase;
      padding-top: ${paddingTop};

      height: auto;
      font-size: ${rem(12)};
      font-weight: 500;
      line-height: ${rem(18)};
      ${mediumUp && css`
        height: 100%;
        font-size: ${rem(11)};
        line-height: ${rem(17)};
      `}
      ${xlargeUp && css`
        font-size: ${rem(13)};
        line-height: ${rem(20)};
      `}

      .nmx-icon {
        display: ${mediumUp ? 'block' : 'none'};
        margin-right: ${rem(7)};
        margin-top: ${mediumUp ? rem(2) : 0};
        float: left;
        .icon-fill {
          fill: ${theme.colors.accent.lightBlue2};
        }
      }
      &:hover,
      &:focus {
        background-color: ${theme.colors.primary.blue};
        text-decoration: underline;
        .nmx-icon {
          .icon-fill {
            fill: ${theme.colors.neutral.white};
          }
        }
      }
    `;
  }
}
`;
